module.exports = __webpack_public_path__ + "static/media/2017_conf_Bringing_Agile_to_your_Extended_Teams.8a6709f0.jpg";